import * as Yup from 'yup';
import { Quotation } from '../../../../../../shared/types/modules/quotation';

export const initialValues: Quotation = {
    callId: '',
    typeQuotation: '',
    typification: '',
    subtypification: '',
    bouquet: '',
    template: '',
    body: '',
    status: '',
    observation: '',
    stage: '',
    policyNumber: '',
    policyDate: undefined,
    motive: '',
    plate: '',
    amount: '',
};

export const validationSchema = (
    subtypification: boolean,
    isRestrictedRole: boolean
) => {
    const schema: any = {
        callId: Yup.string().max(
            100,
            'El call ID debe tener 100 caracteres alfanuméricos como máximo'
        ),
        bouquet: Yup.string().required('El ramo es obligatorio'),
        typification: isRestrictedRole
            ? Yup.string()
            : Yup.string().required('La tipificación  es obligatoria'),
        status: isRestrictedRole
            ? Yup.string()
            : Yup.string().required('El estatus es obligatorio'),
        plate: isRestrictedRole
            ? Yup.string()
            : Yup.string()
                .max(10, 'La placa no puede tener más de 10 caracteres')
                .matches(
                    /^[a-zA-Z0-9\s]*$/,
                    'La placa solo debe contener caracteres alfanuméricos'
                ),
        amount: Yup.number()
            .typeError('El monto debe ser un número válido')
            .min(0, 'El monto no puede ser negativo')
            .test(
                'max-two-decimals',
                'El monto debe tener máximo dos decimales',
                (value) =>
                    value === undefined ||
                    value === null ||
                    Number.isInteger(value * 100)
            ),
    };

    if (subtypification)
        schema.subtypification = Yup.string().required(
            'La subtipificación  es obligatoria'
        );

    return Yup.object(schema);
};
